export const apiRoutes = {
    auth: {
        local: 'auth/local',
    },
    me: '/api/v2/users/me',
    users: '/api/v2/users',
    globalTalentSearch: '/api/v2/users/global-search',
    skills: '/api/v2/users/skills',
    certificates: '/api/v2/certificates',
    uploadMultipleCertificates: '/api/certificates/uploadMultipleCertificates',
    certificateTypes: '/api/v2/certificates/types',
    removeApplicant: (jobId, stafferId) =>
        `/api/v3/jobs/${jobId}/staff/${stafferId}/remove`,
    replaceApplicant: (jobId, stafferId) =>
        `/api/v3/jobs/${jobId}/staff/${stafferId}/replace`,
    hireApplicant: (jobId, applicantId) =>
        `/api/v3/jobs/${jobId}/applicant/${applicantId}/hire`,
    rejectApplicant: (jobId, applicantId) =>
        `/api/v3/jobs/${jobId}/applicant/${applicantId}/reject`,
    holdApplicant: (jobId, applicantId) =>
        `/api/v3/jobs/${jobId}/applicant/${applicantId}/hold`,
    addRecurringStaffer: (groupJobId, stafferId) =>
        `/api/v2/recurringShifts/${groupJobId}/staff/${stafferId}/add`,
    removeRecurringStaffer: (groupJobId, stafferId) =>
        `/api/v2/recurringShifts/${groupJobId}/staff/${stafferId}/remove`,
    replaceRecurringStaffer: (groupJobId, stafferId) =>
        `/api/v2/recurringShifts/${groupJobId}/staff/${stafferId}/replace`,
    hireRecurringApplicant: (groupJobId, applicantId) =>
        `/api/v2/recurringShifts/${groupJobId}/applicant/${applicantId}/hire`,
    rejectRecurringApplicant: (groupJobId, applicantId) =>
        `/api/v2/recurringShifts/${groupJobId}/applicant/${applicantId}/reject`,
    holdRecurringApplicant: (groupJobId, applicantId) =>
        `/api/v2/recurringShifts/${groupJobId}/applicant/${applicantId}/hold`,
    deleteSingleJob: jobId => `/api/v3/jobs/single/${jobId}`,
    deleteMultiDayJob: jobId => `/api/v3/jobs/multi-day/${jobId}`,
    jobs: '/api/v3/jobs',
    jobDetail: jobId => `/api/jobs/${jobId}`,
    lastShiftRate: '/api/v3/jobs/last-rate',
    shiftFillCommandCentre: (jobId, { page, pageSize, refresh } = {}) => {
        const params = new URLSearchParams();
        if (page != null) params.set('page', String(page));
        if (pageSize != null) params.set('pageSize', String(pageSize));
        if (refresh) params.set('refresh', 'true');
        const qs = params.toString();
        return `/api/shift-fill/jobs/${jobId}/command-centre${
            qs ? `?${qs}` : ''
        }`;
    },
    shiftFillDispatchCohort: jobId =>
        `/api/shift-fill/jobs/${jobId}/dispatch-cohort`,
    shiftFillActivity: (jobId, { limit } = {}) => {
        const qs = limit != null ? `?limit=${encodeURIComponent(limit)}` : '';
        return `/api/shift-fill/jobs/${jobId}/activity${qs}`;
    },
    singleRebroadcastShift: id => `/api/v3/jobs/${id}/rebroadcast`,
    recurringRebroadcastShift: id =>
        `/api/v2/recurringShifts/${id}/rebroadcast`,
    // updateJob: jobId => `/api/jobs/${jobId}`,
    jobLogs: jobId => `api/jobLog/fetchSpecificNonRecurringJobLog/${jobId}`,
    recurringJobsLogs: (groupJobId, jobId, pageNumber = 0, pageSize = 20) =>
        `api/jobLog/fetchSpecificRecurringJobLog/${groupJobId}?jobId=${jobId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
    trackerLogs: jobId => `api/trackerLog/fetchSpecificJobLog/${jobId}`,
    smsLogs: 'api/jobs/smsLogs',
    createMultiDayJobs: '/api/v3/jobs/multi-day',
    createRecurringJobs: '/api/v3/jobs/recurring',
    bulkCsvReconcile: '/api/v3/jobs/csv/reconcile',
    bulkCsvCombine: '/api/v3/jobs/csv/combine',
    updateJob: id => `/api/v3/jobs/single/${id}`,
    pastShiftEditStatus: id => `/api/v3/jobs/single/${id}/past-edit-status`,
    updateMultiDayJob: id => `/api/v3/jobs/multi-day/${id}`,
    updateRecurringJob: id => `/api/v3/jobs/multi-day/${id}`,
    entities: '/api/v2/entities',
    addNewShiftAddress: id => `/api/v2/entities/${id}/address`,
    teams: '/api/v2/teams',
    settings: '/api/v2/settings',
    // Admin Settings screen (distinct from the read-only `settings` route above,
    // which the app-wide appSettings slice consumes).
    platformSettings: {
        get: '/api/v2/settings',
        update: '/api/v2/settings',
        referencesView: '/api/v2/settings/references-view',
        messageOfTheDay: '/api/v2/settings/message-of-the-day',
        pendingPaymentTest: province => `/api/pendingPayments/${province}`,
    },
    searchUsers: '/api/users/searchAllStaffers/all',
    createStafferPenalty: userId =>
        `/api/jobs/selectedStaffer/createPenaltyForStaffer/${userId}`,
    createStafferBackgroundCheckFee: userId =>
        `/api/jobs/selectedStaffer/createBackgroundCheckFeeForStaffer/${userId}`,
    getStaffersToAddInUpcomingShift: shiftId =>
        `/api/jobs/getStaffersToAddInUpcomingShifts/${shiftId}`,
    addStaffToShift: (jobId, stafferId) =>
        `/api/v3/jobs/${jobId}/staff/${stafferId}/add`,
    searchEntities: '/api/v2/entities/search',
    uploadProfile: id => `/api/v2/users/${id}/upload/profileUrl`,
    getSkills: '/api/industries',
    skillsByJson: '/api/industries/getSkillsByJson',
    getSubSkills: '/api/industries/subSkill/list',
    validateCompanyNames: '/api/entitys/validateCompanyNames',
    schedulePresets: '/api/schedule-presets',
    blockUser: '/api/v2/block-list',
    addSkill: userId => `api/v2/users/${userId}/skills`,
    skill: skillId => `api/v2/users/skills/${skillId}`,
    reviewSkillExperience: skillId =>
        `api/v2/users/skills/${skillId}/review-experience`,
    subSkill: userId => `api/v2/users/${userId}/sub-skills`,
    addReference: userId => `/api/v2/users/${userId}/references`,
    updateReference: refId => `/api/v2/users/references/${refId}`,
    deleteReference: refId => `/api/v2/users/references/${refId}`,
    deleteCertificate: (userId, certId) =>
        `/api/certificates/deleteCertificate/${userId}/${certId}`,
    sendNotification: '/api/users/sendNotificationToUser/everyone',
    sendAdminNotification: '/api/v2/notifications/send-admin-notification',
    adminNotificationLogs: '/api/v2/notifications/logs',
    sendEmail: '/api/users/sendEmail/withText',
    sendSMS: userId => `/api/users/sendSMSToStaffer/${userId}`,
    addNote: userId => `/api/users/writeNote/${userId}`,
    certificateLogs: userId =>
        `api/userLogs/fetchStafferCertificateLog/${userId}`,
    availabilityLogs: userId =>
        `api/availabilityLog/fetchSpecificStafferLogs/${userId}`,
    acknowledgedBulletins: '/api/bulletin-acknowledgments',
    downloadCompiledBulletin: bulletinId =>
        `/api/bulletin-acknowledgments/bulletins/${bulletinId}/download`,
    declarationLogs: (stafferId, pageNumber = 0, pageSize = 10) =>
        `/api/declarationLog?stafferId=${stafferId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
    sendLatestVSCDeclaration: stafferId =>
        `/api/attestationsAndDeclarations/send-latest/${stafferId}`,
    relilabilityLogs: '/api/reliabilityScores/history',
    revokeLateMark: '/api/reliabilityScores/revoke-late',
    smsHistory: '/api/sms/twilioSMSHistory',
    receiveSMSHistory: '/api/sms/receiveTwilioSMSHistory',
    uploadResume: userId => `api/v2/users/${userId}/upload/resumeUrl`,
    sendResetPasswordEmail: 'api/appInfo/forgotPassword',
    adminResetPassword: userId => `api/users/${userId}/admin-reset-password`,
    uploadUniformPhoto: (id, type) => `/api/v2/users/${id}/upload/${type}`,
    updateUniformPhotoStatus: (id, type) =>
        `/api/v2/users/${id}/uniform-picture/${type}/update-status`,
    resetQuiz: userId => `/api/users/resetQuiz/${userId}`,
    acceptContractor: userId =>
        `/api/v2/users/${userId}/update-status/approve-profile`,
    unApproveContractor: userId =>
        `/api/v2/users/${userId}/update-status/unapprove-profile`,
    rejectContractor: userId =>
        `/api/v2/users/${userId}/update-status/deactivate-profile`,
    blockContractor: userId => `/api/v2/users/${userId}/update-status/block`,
    permaBanPreview: userId => `/api/banned-identities/user/${userId}/preview`,
    permaBanUser: userId => `/api/banned-identities/user/${userId}`,
    clearBanReview: userId => `/api/banned-identities/user/${userId}/review`,
    banContext: '/api/banned-identities/context',
    putContractorUnderReview: userId =>
        `/api/v2/users/${userId}/update-status/under-review`,
    removeFromWaitlist: userId =>
        `/api/v2/users/${userId}/update-status/remove-from-waitlist`,

    moveContractorToWaitlist: userId =>
        `/api/v2/users/${userId}/update-status/move-to-waitlist`,
    rejectedUser: '/api/rejected-user',
    restoreUser: userId => `/api/rejected-user/${userId}/restore`,
    restoreContractor: userId => `/api/users/markRestoreUser/${userId}`,
    userBlocklist: '/api/v2/block-list',
    // Client-side block list for one contractor (block/unblock across clients)
    updateClientBlockList: stafferId =>
        `/api/v2/users/update-block-list/${stafferId}`,
    stopUnPaidInvoices: userId =>
        `api/instantPayment/stopAllUnpaidInvoicesForTheStaffer/${userId}`,
    removedFromUpcomingShifts: userId =>
        `api/jobs/admin/removeStafferFromUpcomingShifts/${userId}`,
    switchToETransfer: () => '/api/berkeleyPayment/e-transfer/setup',
    syncETransferEmail: () => '/api/berkeleyPayment/e-transfer/update',
    checkStafferAvailability: userId =>
        `/api/v2/users/${userId}/check-availability`,
    approveCertificate: certificateId =>
        `/api/v2/certificates/${certificateId}/approve`,
    rejectCertificate: certificateId =>
        `/api/v2/certificates/${certificateId}/reject`,
    revertRejectedCertificate: certificateId =>
        `/api/v2/certificates/${certificateId}/revert-reject`,
    getUserAvailabilityForJob: userId =>
        `/api/v2/users/${userId}/job-availability`,
    forcePassIdVerification: userId => `/api/id-verification/${userId}/pass`,
    clientBadgeList: '/api/physical-badge/badge-names',
    PriorityScoreLogs: userId =>
        `/api/v2/users/${userId}/misc-data/priority-score-logs`,
    deviceChangeRequests: {
        list: '/api/device-change-requests',
        approve: id => `/api/device-change-requests/${id}/approve`,
        reject: id => `/api/device-change-requests/${id}/reject`,
        history: userId => `/api/device-change-requests/user/${userId}/history`,
    },
    userWhitelist: {
        list: '/api/v2/user-whitelist',
        create: '/api/v2/user-whitelist',
        remove: id => `/api/v2/user-whitelist/${id}`,
    },
    mcpTokens: {
        me: '/api/v2/mcp-tokens/me',
        reset: '/api/v2/mcp-tokens/me/reset',
        list: '/api/v2/mcp-tokens',
        revokeFor: userId => `/api/v2/mcp-tokens/${userId}`,
        tokens: '/api/v2/mcp-tokens/me/tokens',
        token: id => `/api/v2/mcp-tokens/me/tokens/${id}`,
        resetToken: id => `/api/v2/mcp-tokens/me/tokens/${id}/reset`,
        revokeToken: id => `/api/v2/mcp-tokens/tokens/${id}`,
    },
    smsBlast: {
        getRecipientsAPI: (province, approval = 'approved') =>
            `/api/users/getSMSListToSpecificSkilledStaffers/admin/${province}/All/${approval}`,
        sendSMS: (province, approval = 'approved') =>
            `/api/users/sendSMSToSpecificSkilledStaffers/admin/${province}/All/${approval}`,
    },
    smsBroadcasts: {
        list: '/api/smsBroadcasts',
        summary: '/api/smsBroadcasts/summary',
        skillBlast: '/api/smsBroadcasts/skill-blast',
        detail: id => `/api/smsBroadcasts/${id}`,
    },
    // Newer AI-call campaign system (server/api/ai-call/campaign/ in staffyapi),
    // separate from the legacy `certificateQueue.aiCall` block below -- that one
    // is misplaced (nested under certificateQueue despite being called as
    // apiRoutes.aiCall.* by AICallModal.jsx/CallLogs.jsx) and is being phased out.
    aiCallCampaigns: {
        previewShift: '/api/ai-call/campaigns/shift/preview',
        launchShift: '/api/ai-call/campaigns/shift',
        previewArea: '/api/ai-call/campaigns/area/preview',
        launchArea: '/api/ai-call/campaigns/area',
        list: '/api/ai-call/campaigns',
        get: id => `/api/ai-call/campaigns/${id}`,
        workers: id => `/api/ai-call/campaigns/${id}/workers`,
        attempts: id => `/api/ai-call/campaigns/${id}/attempts`,
        intelligence: id => `/api/ai-call/campaigns/${id}/intelligence`,
        stop: id => `/api/ai-call/campaigns/${id}/stop`,
        pause: id => `/api/ai-call/campaigns/${id}/pause`,
        resume: id => `/api/ai-call/campaigns/${id}/resume`,
    },
    aiCallAgents: {
        list: '/api/ai-call/agents',
        voices: '/api/ai-call/agents/voices',
        get: id => `/api/ai-call/agents/${id}`,
        update: id => `/api/ai-call/agents/${id}`,
    },
    aiReview: {
        summary: '/api/v2/certificates/ai-review/summary',
        flagged: '/api/v2/certificates/ai-review/flagged',
        action: certificateId =>
            `/api/v2/certificates/${certificateId}/ai-review`,
    },
    certificateQueue: {
        approve: id => `/api/v2/certificates/${id}/approve`,
        reject: id => `/api/v2/certificates/${id}/reject`,
        approveAll: '/api/certificates/approveCategory',
        rejectAll: '/api/certificates/rejectCategory',
        aiCall: {
            createBatchCallRequest: '/api/ai-call/batch-request/',
            getCallLogs: '/api/ai-call/logs',
            getAgents: '/api/ai-call/batch-request/available-agents',
            getNearByUsers: '/api/v2/users/',
            getBatchRequestById: id => `/api/ai-call/batch-request/${id}`,
        },
        updateType: id => `/api/v2/certificates/${id}/update-type`,
        clearExpiry: id => `/api/v2/certificates/${id}/clear-expiry`,
        getCertificateTypes: '/api/v2/certificates/types',
    },
    userLogs: userId => `/api/userLogs/actions/${userId}`,
    breakShiftByStaffers: jobId => `/api/jobs/breakShiftByStaffers/${jobId}`,
    breakRecurringShiftByStaffers:
        '/api/recurringShifts/breakRecurringShiftByStaffers/',
    recurrenceRules: {
        list: '/api/recurrentShiftTemplate/admin',
        detail: id => `/api/recurrentShiftTemplate/admin/${id}`,
        // Mirrors the staffy-ionic-v2 two-call delete pattern:
        //   1. delete the template (stops the extend-shifts cron)
        //   2. delete future shifts in the linked group
        deleteTemplate: id => `/api/recurrentShiftTemplate/${id}`,
        deleteUpcomingShifts: groupShiftId =>
            `/api/recurringShifts/admin/deleteShift/${groupShiftId}`,
    },
    // Shifts > Time Tracker (paginated list + live tracker controls)
    timeTracker: {
        list: '/api/jobs/timeTracker',
        start: '/api/tracker/start',
        pause: '/api/tracker/pause',
        resume: '/api/tracker/resume',
        stop: '/api/tracker/stop',
    },
    // Tracker editing APIs
    createTracker: 'api/v2/tracker',
    updateTracker: trackerId => `api/v2/tracker/${trackerId}`,
    // Billing / invoice payment
    finalizeBilling: invoiceId =>
        `/api/v2/invoices/${invoiceId}/invoice-payment`,
    getInvoice: invoiceId => `/api/v2/invoices/${invoiceId}`,
    // Manual invoice creation
    createManualInvoice: '/api/v2/invoices/manual',
    // Send a one-off bonus payment to a contractor's wallet
    sendContractorPayment: '/api/v2/contractor-payments',
    validateContractorPaymentInvoice: invoiceNo =>
        `/api/v2/contractor-payments/validate-invoice/${encodeURIComponent(
            invoiceNo,
        )}`,
    // Staffer Penalty (cancellation fees + manual background-check fee).
    // These live on the legacy /api/jobs controller (job.controller.js
    // createPenaltyForStaffer / createBackgroundCheckFeeForStaffer); there is
    // no /api/v2/staffer-penalties resource on the backend. `penaltyAmount`
    // and `stafferPenalties` are plain fields on the user document, so the
    // current fee is read from the v2 user endpoint.
    stafferPenalties: {
        details: userId => `/api/v2/users/${userId}`,
        cancellationFee: userId =>
            `/api/jobs/selectedStaffer/createPenaltyForStaffer/${userId}`,
        backgroundCheckFee: userId =>
            `/api/jobs/selectedStaffer/createBackgroundCheckFeeForStaffer/${userId}`,
    },
    contractorInvoices: '/api/v2/invoices',
    receipts: '/api/receipts',
    receiptsV2: '/api/v2/receipts',
    sendInvoiceEmail: invoiceId => `/api/v2/invoices/${invoiceId}/email`,
    markInvoicePaid: invoiceId => `/api/v2/invoices/${invoiceId}/mark-paid`,
    applyCreditOnInvoice: invoiceId =>
        `/api/v2/invoices/${invoiceId}/apply-credit`,
    removeFeeFromInvoice: invoiceId =>
        `/api/v2/invoices/${invoiceId}/remove-fee`,
    updateInvoice: invoiceId => `/api/v2/invoices/${invoiceId}`,
    // Manually re-attempt the Stripe pre-authorization for a shift invoice.
    // Hits manuallyReservePaymentForInvoice (server/api/invoices/invoice.controller.js).
    // Backend now refunds any existing chargeId before reserving to avoid orphans.
    tryPreAuthAgain: invoiceId => `/api/invoicesNewModel/${invoiceId}`,
    // Weekly Invoice Review actions and bulk Mark Invoices. Same v1 routes
    // admin 1 calls, so both panels do exactly the same thing.
    weeklyInvoiceApproveAndEmail: province =>
        `/api/invoicesNewModel/emailInvoice/sendingOneInvoiceInEmail/${province}/invoice`,
    weeklyInvoicesEmailSelected: '/api/invoicesNewModel/sendMultipleInvoices',
    weeklyInvoiceApplyCredit: invoiceId =>
        `/api/invoicesNewModel/applyWallet/${invoiceId}/applyCreditAmountOnInvoice`,
    invoicesBySerialNo: serialNos =>
        `/api/invoicesNewModel/fetchInvoices/UnpopulatedByInvoiceNumbers/${serialNos}`,
    // The literal "invoiceId" is matched by POST /:invoiceId; with a
    // body.invoices array the controller marks every one of them paid.
    bulkMarkInvoicesPaid: '/api/invoicesNewModel/invoiceId',
    // Geocode
    bulkGeocodeAddresses: '/api/geocode/bulk-addresses',
    // Berkeley Payment Logs
    berkeleyPaymentLogs: '/api/v2/berkeleyPayment',
    berkeleyPaymentTransaction: transactionId =>
        `/api/v2/berkeleyPayment/transactions/${transactionId}`,
    berkeleyPaymentTransactions: '/api/berkeleyPayment/transactions',
    // Wallet Payments
    walletPaymentsAdmin: '/api/v2/walletPayments/admin',
    walletPaymentsAdminChart: '/api/v2/walletPayments/admin/chart',
    walletFundsProjection: '/api/v2/walletPayments/admin/funds-projection',
    walletEmergencyFloatStatus: '/api/v2/emergency-float',
    walletEmergencyFloatAddFunds: '/api/v2/emergency-float/add-funds',
    walletEmergencyFloatResetAll: '/api/v2/emergency-float/reset-all',
    walletEmergencyFloatReleaseStafferOnce:
        '/api/v2/emergency-float/release-staffer-once',
    walletEmergencyFloatCancelRelease: '/api/v2/emergency-float/cancel-release',
    walletEmergencyFloatAuditLogs: '/api/v2/emergency-float/audit-logs',
    // Client Reconciliation
    clientReconciliation: entityId => `/api/v2/reconciliation/${entityId}`,
    clientReconciliationExport: entityId =>
        `/api/v2/reconciliation/${entityId}/export`,
    trainingRequests: {
        list: '/api/v2/trainingRequests',
        export: '/api/v2/trainingRequests/export',
    },
    // Account Statement
    accountStatement: '/api/v2/account-statement',
    accountStatementClients: '/api/v2/account-statement/clients',
    accountStatementExport: '/api/v2/account-statement/export',
    accountStatementEmail: '/api/v2/account-statement/email',
    statementGroups: '/api/groupStatements/getllgroupStatements',
    createStatementGroup: '/api/groupStatements/',
    // Stat Pay
    updateJobStatPay: jobId => `/api/v3/jobs/${jobId}/stat-pay`,
    updateRecurringShiftStatPay: id => `/api/v2/recurringShifts/${id}/stat-pay`,
    // Map
    mapShifts: '/api/v2/map/shifts',
    mapContractors: '/api/v2/map/contractors',
    mapEntities: '/api/v2/map/entities',
    mapContractorSearch: '/api/v2/map/contractor-search',
    mapShiftContext: shiftId => `/api/v2/map/shift/${shiftId}/context`,
    // Email Marketing
    emailCampaigns: {
        list: '/api/emailCampaigns',
        summary: '/api/emailCampaigns/summary',
        dryRun: '/api/emailCampaigns/dry-run',
        detail: id => `/api/emailCampaigns/${id}`,
        send: id => `/api/emailCampaigns/${id}/send`,
        schedule: id => `/api/emailCampaigns/${id}/schedule`,
        cancel: id => `/api/emailCampaigns/${id}/cancel`,
        duplicate: id => `/api/emailCampaigns/${id}/duplicate`,
        testSend: id => `/api/emailCampaigns/${id}/test-send`,
        searchClients: '/api/emailCampaigns/search-clients',
    },
    emailUnsubscribes: {
        list: '/api/emailUnsubscribes',
        remove: id => `/api/emailUnsubscribes/${id}`,
    },
    emailTemplates: {
        list: '/api/emailTemplates',
        detail: id => `/api/emailTemplates/${id}`,
        duplicate: id => `/api/emailTemplates/${id}/duplicate`,
    },
    emailAssets: {
        list: '/api/emailAssets',
        upload: '/api/emailAssets/upload',
        remove: id => `/api/emailAssets/${id}`,
    },
    emailAudienceLists: {
        list: '/api/emailAudienceLists',
        detail: id => `/api/emailAudienceLists/${id}`,
        count: id => `/api/emailAudienceLists/${id}/count`,
    },
    emailCampaignImportCsv: id => `/api/emailCampaigns/${id}/import-csv`,
    // Reports — only create hits web.1 to run on the worker dyno
    reports: {
        createTransaction: '/api/v2/reports/transactions',
        listTransactions: '/api/v2/reports/transactions',
        transactionStatus: id => `/api/v2/reports/transactions/${id}/status`,
        deleteTransaction: id => `/api/v2/reports/transactions/${id}`,
        checkExisting: '/api/v2/reports/transactions/check-existing',
        workerBaseUrl:
            window.location.hostname === 'admin-v2.staffy.com'
                ? 'https://web.1.staffy.com'
                : undefined,
    },
    clientInvoiceReports: {
        create: '/api/v2/reports/client-invoices',
        list: '/api/v2/reports/client-invoices',
        status: id => `/api/v2/reports/client-invoices/${id}/status`,
        delete: id => `/api/v2/reports/client-invoices/${id}`,
        checkExisting: '/api/v2/reports/client-invoices/check-existing',
        workerBaseUrl:
            window.location.hostname === 'admin-v2.staffy.com'
                ? 'https://web.1.staffy.com'
                : undefined,
    },
    userSignupsReports: {
        create: '/api/v2/reports/user-signups',
        list: '/api/v2/reports/user-signups',
        status: id => `/api/v2/reports/user-signups/${id}/status`,
        delete: id => `/api/v2/reports/user-signups/${id}`,
        checkExisting: '/api/v2/reports/user-signups/check-existing',
        workerBaseUrl:
            window.location.hostname === 'admin-v2.staffy.com'
                ? 'https://web.1.staffy.com'
                : undefined,
    },
    filledUnfilledReports: {
        create: '/api/v2/reports/filled-unfilled',
        list: '/api/v2/reports/filled-unfilled',
        status: id => `/api/v2/reports/filled-unfilled/${id}/status`,
        delete: id => `/api/v2/reports/filled-unfilled/${id}`,
        checkExisting: '/api/v2/reports/filled-unfilled/check-existing',
        workerBaseUrl:
            window.location.hostname === 'admin-v2.staffy.com'
                ? 'https://web.1.staffy.com'
                : undefined,
    },
    shiftApplicationsReports: {
        create: '/api/v2/reports/shift-applications',
        list: '/api/v2/reports/shift-applications',
        status: id => `/api/v2/reports/shift-applications/${id}/status`,
        delete: id => `/api/v2/reports/shift-applications/${id}`,
        checkExisting: '/api/v2/reports/shift-applications/check-existing',
        workerBaseUrl:
            window.location.hostname === 'admin-v2.staffy.com'
                ? 'https://web.1.staffy.com'
                : undefined,
    },
    weeklyInvoiceVerification: '/api/v2/invoices/weekly-pending-verification',
    weeklyUnitNumbers: '/api/v2/invoices/weekly-unit-numbers',
    billingVerification: '/api/v2/invoices/billing-verification',
    weeklyTransactionReport: '/api/v2/invoices/weekly-report',
    instantPayReport: '/api/v2/reports/instant-pay',
    paidContractorInvoicesReport: '/api/v2/reports/paid-contractor-invoices',
    contractorWithdrawalsReport: '/api/v2/reports/contractor-withdrawals',
    manualTimeRequests: '/api/v2/manualTimeRequest',
    approveOrRejectManualTimeRequest: id =>
        `/api/v2/manualTimeRequest/approveOrReject/${id}`,
    // Admin 1.0 parity endpoints for approving a manual time request.
    confirmLoggedHours: stafferId =>
        `api/tracker/confirmLoggedHours/${stafferId}`,
    createTrackerManually: 'api/tracker/createTracker/manually',
    updateTrackerV1: 'api/tracker/tracker/updateTracker',
    invoicesNewModel: invoiceId => `api/invoicesNewModel/${invoiceId}`,
    approveManualHoursRequest: id =>
        `api/manualHoursLogged/approveOrDisapprove/${id}`,
    walletBalanceAgingReport: '/api/v2/reports/wallet-balances',
    // Payment > Disputes
    disputes: '/api/v2/disputes',
    resolveDispute: jobId => `/api/v2/disputes/${jobId}/resolve`,
    payInvoiceFromDispute: invoiceId =>
        `/api/jobs/automateTransaction/${invoiceId}`,
    // ---- Companies > Approved: per-row action endpoints ----
    // Reusing existing v1 endpoints (established convention) for company/entity mutations.
    // User-side
    updateCompanyUser: id => `/api/v2/users/${id}`,
    // Legacy v1 user update (used by alternate-emails / email-categories / contacts,
    // matching Admin 1.0 which stores those fields on the user via PUT /api/users/:id)
    updateUserLegacy: id => `/api/users/${id}`,
    markDeleteCompany: userId => `/api/users/markDeleteUser/${userId}`,
    // Companies > Other approve/reject. Same v2 update-status endpoints the talent
    // screens use — updateUserStatus already branches on type === 'employer'
    // (archiving the entity on reject), so no company-specific endpoint is needed.
    // Aliased for readability at the call site.
    approveCompany: userId =>
        `/api/v2/users/${userId}/update-status/approve-profile`,
    rejectCompany: userId =>
        `/api/v2/users/${userId}/update-status/deactivate-profile`,
    companyCardList: id => `/api/users/cardList/${id}`,
    removeCompanyCard: id => `/api/users/removeCard/${id}`,
    companySecondaryLogins: id => `/api/users/${id}/secondary-logins`,
    // Company-side block list (company user's blocked_list of staffers)
    companyBlockStaffer: companyUserId =>
        `/api/users/blockbyId/${companyUserId}`,
    companyUnblockStaffer: companyUserId =>
        `/api/users/userUnblock/${companyUserId}`,
    // Entity-side (note the legacy "entitys" mount path)
    updateEntity: id => `/api/entitys/${id}`,
    customizeSkillRates: id => `/api/entitys/${id}/customizeSkillRates`,
    updateEntitySkillExperience: id =>
        `/api/entitys/${id}/updateSkillExperience`,
    excludeSubSkills: id => `/api/entitys/${id}/excludeSubSkills`,
    entityStatPaySettings: id => `/api/entitys/${id}/statPaySettings`,
    entityUnitNumber: id => `/api/entitys/${id}/unitNumber`,
    updateEntityBulletins: id => `/api/entitys/${id}/update/bulletins`,
    entityTasks: id => `/api/entitys/${id}/tasks`,
    entityTask: (id, taskId) => `/api/entitys/${id}/tasks/${taskId}`,
    unitContact: entityId => `/api/unit/${entityId}/persons`,
    // Credential requirements
    certificateRequirements: '/api/certificateRequirements',
    entityCertificateRequirements: entityId =>
        `/api/certificateRequirements/${entityId}/requirements`,
    getCertificateRequirement: (entityId, brand) =>
        `/api/certificateRequirements/client/${entityId}/${brand}`,
    // Schedule presets
    schedulePresetsBulk: '/api/schedule-presets/bulk',
    // FAQs
    faqs: {
        list: type => `/api/v2/faqs/${type}`,
        create: '/api/v2/faqs',
        update: id => `/api/v2/faqs/${id}`,
        remove: id => `/api/v2/faqs/${id}`,
    },
};
